export const BUZZ_ENTER_DRAW = 'enter-draw';

export enum CTA_TYPES {
    close = 'close',
    navigate = 'navigate',
    gameLaunch = 'gameLaunch',
}
